import * as React from 'react'
import { ModalBox } from '$views/components/ModalBox'
import { PrivacyPolicyModal } from '$views/components/PrivacyPolicyModal'
import { Text } from '$views/components'
import { ContactStepForm } from '$views/RecommendationsForms/BroadcastForm/ContactStep/ContactStepForm/ContactStepForm'
import { draft } from '$utils/services/formDraftService'
import { broadcastFormDraftName, broadcastFormSteps } from '$views/RecommendationsForms/BroadcastForm/BroadcastForm'
import { BroadcastContactFormValues } from '$views/RecommendationsForms/BroadcastForm/ContactStep/ContactStepForm/ContactStepForm.model'
import { Spinner } from '$views/components/Spinner'
import { createNewBroadcastService } from '$services/customer/broadcastService/broadcastService.service'
import history from '$utils/history'
import { routeProvider } from '$utils/routeProvider'
import { formatError } from '$views/components/Error/Error.mapper'
import { ErrorView } from '$views/components/Error/Error.model'
import { Error } from '$views/components/Error'
import { guest } from '$utils/services/guestUserService'

export const ContactStep: React.FC = () => {
  const [isTermsAndPolicyAccept, setTermsAndPolicyAccept] = React.useState<boolean>(false)
  const [showInfoPolicyNotification, setShowInfoPolicyNotification] = React.useState<boolean>(false)
  const [showTermsAndPolicyNotification, setShowTermsAndPolicyNotification] = React.useState<boolean>(false)
  const [isLoading, handleLoading] = React.useState<boolean>(false)
  const [errorNotification, setErrorNotification] = React.useState<ErrorView>()
  const [showErrorNotification, handleShowErrorNotification] = React.useState<boolean>(false)

  const closeInfoPolicyNotification = () => setShowInfoPolicyNotification(false)

  const displayInfoPolicyNotification = () => setShowInfoPolicyNotification(true)

  const hideTermsAndPolicyNotification = () => setShowTermsAndPolicyNotification(false)

  const displayTermsAndPolicyNotification = () => setShowTermsAndPolicyNotification(true)

  const switchTermsAndPolicyAccept = () => setTermsAndPolicyAccept(termsAndPolicyAccept => !termsAndPolicyAccept)

  const setErrors = errors => {
    setErrorNotification(errors)
    handleShowErrorNotification(true)
  }

  const onSubmit = async (customerData: BroadcastContactFormValues) => {
    if (isTermsAndPolicyAccept) {
      handleLoading(true)
      try {
        const draftValues = draft.get(broadcastFormDraftName)
        draft.set(broadcastFormDraftName, {
          ...draftValues,
          [broadcastFormSteps.contactStep]: {
            ...customerData,
          },
        })
        await createNewBroadcastService()
        guest.setEmail(customerData.email)
        guest.setName(customerData.name)
        history.push(routeProvider.broadcastFormConfirmation)
        handleLoading(false)
      } catch (error) {
        const broadcastError = formatError(error)
        setErrors(broadcastError)
        handleLoading(false)
      }
    } else {
      displayTermsAndPolicyNotification()
    }
  }

  return (
    <>
      {isLoading && <Spinner />}
      {showErrorNotification && <Error error={errorNotification} onClick={() => handleShowErrorNotification(false)} />}
      {showInfoPolicyNotification && <PrivacyPolicyModal onClose={closeInfoPolicyNotification} />}
      {showTermsAndPolicyNotification && (
        <ModalBox onAcceptClick={hideTermsAndPolicyNotification} buttonLabel={'Aceptar'} simple>
          Debes aceptar nuestra política de privacidad y los términos y condiciones de nuestro servicio
        </ModalBox>
      )}
      <Text title>Te avisamos cuando tengas candidatas</Text>
      <Text marginTop="base" marginBottom="mini">
        Te llegará un email en cuanto tengas la primera candidata. Y podrás chatear con ella directamente.
      </Text>
      <ContactStepForm
        onSubmit={onSubmit}
        setTermsAndPolicyAccept={switchTermsAndPolicyAccept}
        isTermsAndPolicyAccept={isTermsAndPolicyAccept}
        onClickPrivacyPolicy={displayInfoPolicyNotification}
      />
    </>
  )
}



// WEBPACK FOOTER //
// ./src/views/RecommendationsForms/BroadcastForm/ContactStep/ContactStep.tsx